"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const charts_1 = require("@amcharts/amcharts4/charts");
const am4core = require("@amcharts/amcharts4/core");
const animated_1 = require("@amcharts/amcharts4/themes/animated");
const core_1 = require("@angular/core");
const data_formatter_1 = require("../../../views/list/helper/data-formatter");
const chart_base_control_1 = require("../chart-base.control");
const chart_control_options_model_1 = require("../shared/chart-control-options.model");
let PieChartControlComponent = 
/**
 * This component creates Pie Charts according to passed parameters.
 */
class PieChartControlComponent extends chart_base_control_1.ChartBaseControl {
    constructor(ngZone) {
        super();
        this.ngZone = ngZone;
        this.drillDownMessage = '';
        this.drillDownPages = [];
        this.isDrillDownOpened = false;
        this.LABELS_MAX_LENGTH = 20;
        this.goToEvent = new core_1.EventEmitter();
    }
    /**
     * This method is called when one of the input parameters is changed. Afterwards the charts is updated.
     */
    ngOnChanges(simpleChanges) {
        if (simpleChanges['data'] && !simpleChanges['data'].isFirstChange()) {
            this.setChartData();
        }
    }
    ngOnInit() {
        this.ngZone.runOutsideAngular(() => {
            this.initChart();
        });
    }
    ngOnDestroy() {
        this.ngZone.runOutsideAngular(() => {
            this.chart.dispose();
        });
    }
    initChart() {
        this.chart = am4core.create(this.chartContainerElement.nativeElement, charts_1.PieChart);
        this.chartSeries = this.chart.series.push(new charts_1.PieSeries());
        this.configureChartDefaults();
        this.setChartData();
        this.setChartOptions();
    }
    setChartData() {
        this.chart.data = this.data;
    }
    configureChartDefaults() {
        am4core.useTheme(animated_1.default);
        // set data fields mapping
        this.chartSeries.dataFields.value = 'value';
        this.chartSeries.dataFields.category = 'category';
        // format data labels and truncate long labels
        this.chartSeries.labels.template.text = '{category} - {value.percent.formatNumber(\'#.00\')}%';
        this.chartSeries.labels.template.adapter.add('textOutput', (value) => {
            return this.processLabel(value);
        });
        // configure tooltip setting to be clickable
        this.chartSeries.tooltip.label.interactionsEnabled = true;
        this.chartSeries.tooltip.keepTargetHover = true;
        // configure tooltip html content
        this.chartSeries.slices.template.adapter.add('tooltipHTML', (value, target) => {
            this.dataItem = target.dataItem.dataContext;
            this.dataItem.value = data_formatter_1.formatNumber(this.dataItem.value, this.dataItem.symbol);
            this.drillDownPages = this.dataItem.pages;
            if (this.drillDownPages.length !== 0 && this.dataItem.categoryId !== undefined) {
                this.drillDownData = {
                    categoryId: this.dataItem.categoryId,
                    categoryName: this.dataItem.category
                };
            }
            let tooltipTemplate = '<div class="rc-pie-tooltip">';
            if (this.dataItem.measure) {
                tooltipTemplate +=
                    `<div class="rc-pie-tooltip__title">
                        ${this.dataItem.category}
                    </div>
                    <div class="rc-pie-tooltip__property">
                        <div class="rc-pie-tooltip__text">${this.dataItem.measure}</div>
                        <div class="rc-pie-tooltip__value">${this.dataItem.value}</div>
                    </div>`;
            }
            else {
                tooltipTemplate +=
                    `<div class="rc-pie-tooltip__title rc-pie-tooltip__property">
                        <div class="rc-pie-tooltip__text">${this.dataItem.category}</div>
                        <div class="rc-pie-tooltip__value">${this.dataItem.value}</div>
                    </div>`;
            }
            if (this.dataItem.categoryId !== undefined && this.drillDownPages.length !== 0) {
                tooltipTemplate +=
                    `<div class="rc-pie-tooltip__title">
                        ${this.drillDownMessage}
                    </div>`;
                this.drillDownPages.forEach((drillDownPage) => {
                    tooltipTemplate +=
                        `<div id="${drillDownPage.value}" class="rc-pie-tooltip__link">
                            ${drillDownPage.name}
                        </div>`;
                });
            }
            tooltipTemplate += '</div>';
            return tooltipTemplate;
        });
        // Handle click event of tooltip, filter clicks of drill down pages and process accordingly
        this.chartSeries.tooltip.events.on('hit', (event) => {
            const target = event.event.target;
            if (target.className === 'rc-pie-tooltip__link') {
                this.goToPage(target.id);
            }
        });
    }
    setChartOptions() {
        if (this.chartOptions) {
            this.setSeriesDefaultOptions();
            this.setLegendDefaultOptions();
            this.setResponsiveDefaultOptions();
            this.setRTLDefaultOptions();
        }
    }
    setSeriesDefaultOptions() {
        this.chartSeries.colors.list = this.chartOptions.chartPalette.map(color => am4core.color(color));
        this.chartSeries.slices.template.stroke = am4core.color("#fff");
        this.chartSeries.slices.template.strokeWidth = 0.16;
        this.chartSeries.labels.template.fontSize = 12;
        this.chartSeries.labels.template.paddingTop = 2;
        this.chartSeries.labels.template.paddingBottom = 2;
        this.chartSeries.tooltip.getFillFromObject = false;
        this.chartSeries.tooltip.background.fill = am4core.color("#fff");
    }
    setResponsiveDefaultOptions() {
        // Responsive Options
        this.chart.responsive.enabled = true;
        this.chart.responsive.rules.push({
            relevant: (target) => {
                return target.pixelWidth <= 480;
            },
            state: (target, stateId) => {
                if (target instanceof charts_1.PieSeries) {
                    const state = target.states.create(stateId);
                    const labelState = target.labels.template.states.create(stateId);
                    labelState.properties.disabled = true;
                    const tickState = target.ticks.template.states.create(stateId);
                    tickState.properties.disabled = true;
                    return state;
                }
                return null;
            }
        });
    }
    setRTLDefaultOptions() {
        if (this.chartOptions.isRTL) {
            // Set RTL for labels
            this.chart.rtl = true;
            // Change the order of the items in legend, so that first item starts on the right
            this.chart.legend.reverseOrder = true;
            // Flip legend
            this.chart.legend.itemContainers.template.reverseOrder = true;
        }
    }
    /**
     * Truncate long data labels
     * @param text
     * @private
     */
    processLabel(text) {
        const indexOfDelimiter = text.lastIndexOf('-');
        const categoryText = text.slice(0, indexOfDelimiter - 1);
        const percentText = text.slice(indexOfDelimiter);
        if (categoryText.length > this.LABELS_MAX_LENGTH) {
            text = categoryText.substring(0, this.LABELS_MAX_LENGTH - 3) + "... " + percentText;
            return text;
        }
        return text;
    }
    goToPage(pageId) {
        this.drillDownData.pageId = pageId;
        this.goToEvent.emit(this.drillDownData);
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PieChartControlComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", chart_control_options_model_1.ChartControlOptions)
], PieChartControlComponent.prototype, "chartOptions", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], PieChartControlComponent.prototype, "data", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], PieChartControlComponent.prototype, "drillDownMessage", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], PieChartControlComponent.prototype, "goToEvent", void 0);
__decorate([
    core_1.ViewChild('chartContainer'),
    __metadata("design:type", core_1.ElementRef)
], PieChartControlComponent.prototype, "chartContainerElement", void 0);
PieChartControlComponent = __decorate([
    core_1.Component({
        
        selector: "sis-pie-chart-control",
        styles: [require('./sis-pie-chart-control.component.css')],
        template: require('./sis-pie-chart-control.component.html'),
        changeDetection: core_1.ChangeDetectionStrategy.OnPush
    })
    /**
     * This component creates Pie Charts according to passed parameters.
     */
    ,
    __metadata("design:paramtypes", [core_1.NgZone])
], PieChartControlComponent);
exports.PieChartControlComponent = PieChartControlComponent;
//# sourceMappingURL=sis-pie-chart-control.component.js.map